module.exports = __webpack_public_path__ + "img/icon_real_role.b1a88121.svg";